module.exports = __webpack_public_path__ + "img/signatures.5ffe07d0.svg";